import { ISlideComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/types';
import { ILayerService } from '../../canvas-render/slide/layered-render/plalyer-state-layered/player-layer-interface';

export function getTargetComponent(
    targetModelKey: string,
    slideComponent?: ISlideComponent|null,
    layerService?: ILayerService,
): any {
    if (!targetModelKey || !slideComponent) return;
    let animTarget = slideComponent?.elementsLayer.children?.find((childComponent: any) => {
        const modelKey = childComponent?.factoryOptions?.model?.key;
        return modelKey === targetModelKey;
    });
    if (animTarget) return animTarget;
    animTarget = layerService?.findAnimTargetInOverlayLayer(targetModelKey);
    if (animTarget) return animTarget;
    animTarget = layerService?.findAnimTargetInOperationLayer(targetModelKey);
    return animTarget;
}
